<template>
    <v-list dense>
        <v-list-group append-icon v-for="(group, groupIndex) in filtered" :key="groupIndex">
            <template v-slot:activator>
                <v-list-item-icon>
                    <v-icon dense>{{ group.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ group.text }}</v-list-item-title>
            </template>
            <v-list-item link v-for="(item, itemIndex) in group.items" :key="itemIndex" :to="item.to" dense>
                <v-list-item-icon>
                    <v-icon dense>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
        </v-list-group>
    </v-list>
</template>

<script>
import authorize from '../../utils/authorize';
export default {
    name: "NavDrawerList",
    props: {
        groups: {
            required: true,
            type: Array
        }
    },
    computed: {
        filtered() {
            let groups = this.groups.map(group => {
                group.items = group.items.filter(item => authorize(item.authorization));
                return group;
            })

            return groups.filter(group => group.items.length > 0);
        }
    }
};
</script>

<style></style>
